// extracted by mini-css-extract-plugin
module.exports = {"title":"firstScreen_title__2IMza","row":"firstScreen_row__RJYIF","center":"firstScreen_center__1KJH5","description":"firstScreen_description__3YezR"};